import Swiper from 'swiper';
import { Navigation, Mousewheel, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Mousewheel, Pagination]);

const events = window.PointerEvent ? {
    up: 'pointerup',
    enter: 'pointerenter',
    leave: 'pointerleave',
} : {
    up: 'touchend',
    enter: 'mouseenter',
    leave: 'mouseleave',
};

const initGalleries = (galleries) => {
    galleries.forEach((gallery) => {
        const options = {
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
            },
            pagination: {
                el: gallery.parentNode.querySelector('.swiper-pagination'),
                clickable: true,
                bulletActiveClass: '!opacity-80',
                renderBullet: (index, className) => `<button class="${className} size-2 bg-black rounded-full opacity-40 pointer-events-auto"></button>`,
            },
        };

        if (gallery.dataset.centeredSlides !== undefined) {
            options.centeredSlides = true;
        }

        if (gallery.dataset.slidesPerView !== undefined) {
            options.slidesPerView = gallery.dataset.slidesPerView;
        }

        if (gallery.dataset.spaceBetween !== undefined) {
            options.spaceBetween = parseInt(gallery.dataset.spaceBetween, 10);
        }

        if (gallery.dataset.breakpoints !== undefined) {
            options.breakpoints = JSON.parse(gallery.dataset.breakpoints);
        }

        const galleryThumbs = [...gallery.parentNode.querySelectorAll('.js-gallery-thumb')];
        if (galleryThumbs.length > 0) {
            options.autoHeight = true;
            options.on = {
                slideChange: (self) => {
                    galleryThumbs.forEach((galleryThumb) => {
                        galleryThumb.classList.remove('is-selected');
                    });
                    galleryThumbs[self.activeIndex].classList.add('is-selected');
                },
            };
        }

        const galleryNav = gallery.parentNode.querySelector('.swiper-button-next');
        if (galleryNav) {
            options.navigation = {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            };
        }

        const swiper = new Swiper(gallery, options);

        setTimeout(() => {
            swiper.updateSize();
        }, 1000);

        galleryThumbs.forEach((galleryThumb, index) => {
            galleryThumb.addEventListener(events.up, () => {
                swiper.slideTo(index);
            });
        });
    });
};

const init = () => {
    const linkedProductsSelect = document.querySelector('.js-select-linked-product');
    if (linkedProductsSelect) {
        linkedProductsSelect.addEventListener('change', () => {
            window.location = linkedProductsSelect.value;
        });
    }

    const galleries = document.querySelectorAll('.js-gallery');
    if (galleries.length > 0) initGalleries(galleries);
};

export default init;
